export const PanelID = $localize`Test Panel ID`;
export const Name = $localize`App Config Name`;
export const Description = $localize`App Config Description`;
export const CreatedByUser = $localize`User`;
export const CreatedOn = $localize`Created On`;
export const Status = $localize`Status`;
export const Applications = $localize`Applications`;
export const Project = $localize`Project`;

export const displayedColumns = [`name`, `description`, `groupName`, `applications`, `userName`, `createdOn`, `status`];
